const mock = {
    "results": {
      "score": 3,
      "maxScore": 10
    },
    "submissionDate": "2024-09-04T21:02:17.5196399+00:00",
    "passed": false,
    "sealed": true,
    "questions": [
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "6d9bb17e-26c6-4f08-b00e-526b2c6d55e4",
        "type": "MultiChoice",
        "content": "Why is offering further assistance to the guest important?",
        "options": [
          {
            "id": 0,
            "value": "It helps the staff save time"
          },
          {
            "id": 1,
            "value": "It is a requirement, but it doesn't impact the guest's experience"
          },
          {
            "id": 2,
            "value": "It's unnecessary as guests usually decline additional help"
          },
          {
            "id": 3,
            "value": "Tailoring service to individual guest preferences and needs"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "de12f198-4310-4c97-8e0a-6ca8702e3349",
        "type": "SingleChoice",
        "content": "How can an attendant personalize service without breaching guest privacy?",
        "options": [
          {
            "id": 0,
            "value": "Avoid using guest names"
          },
          {
            "id": 1,
            "value": "Share personal anecdotes about the attendant"
          },
          {
            "id": 2,
            "value": "Use learned information discreetly"
          },
          {
            "id": 3,
            "value": "Request personal details from the guest"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "a7ef20d6-23df-40df-b0d7-a0fcd6f01ccb",
        "type": "MultiChoice",
        "content": "Which one is the wrong answer for the check-in procedure?",
        "options": [
          {
            "id": 0,
            "value": "Provide room number either verbally or non-verbally"
          },
          {
            "id": 1,
            "value": "To offer assistance for the internet during check in"
          },
          {
            "id": 2,
            "value": "Ask the number of room keys required"
          },
          {
            "id": 3,
            "value": "Use appropriate verbiage with genuine delivery"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "9dffdb81-0bc3-48da-adef-a721c129e669",
        "type": "MultiChoice",
        "content": "What is the length of check in process according to the standards?",
        "options": [
          {
            "id": 0,
            "value": "4 minutes"
          },
          {
            "id": 1,
            "value": "5 minutes"
          },
          {
            "id": 2,
            "value": "7 minutes"
          },
          {
            "id": 3,
            "value": "10 minutes"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "4e06a134-9ca9-4ccf-a5d9-07edd00b85c2",
        "type": "SingleChoice",
        "content": "Front desk associate needs to offer enrollment into Marriott Bonvoy to the guest without it at check out.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "3af84708-9f5a-4a51-8b95-69d5c67a7b5b",
        "type": "MultiChoice",
        "content": "Which answer is not correct when owning and resolving the guest request?",
        "options": [
          {
            "id": 0,
            "value": "Listen actively"
          },
          {
            "id": 1,
            "value": "Express empathy"
          },
          {
            "id": 2,
            "value": "Resolve/solve the problem within 30 minutes"
          },
          {
            "id": 3,
            "value": "Apologize and assume ownership"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "d9afe4c3-02ca-4c94-ada8-f72fda621fed",
        "type": "SingleChoice",
        "content": "Front desk agent should offer transportation to the guest during the check out.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "814def0e-01da-4e8c-a1b9-db530ee3e6a8",
        "type": "SingleChoice",
        "content": "Maintaining poor posture, a smile, eye contact, and attentive listening is the responsibility of every front desk agent throughout guest interactions.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "d7cc3525-dede-4beb-b16b-3eaf51b445cf",
        "type": "MultiChoice",
        "content": "What is one responsibility of a front desk agent when seeing a guest waiting in a queue?",
        "options": [
          {
            "id": 0,
            "value": "Ignore them until they approach the desk"
          },
          {
            "id": 1,
            "value": "Ask them to leave if they're taking too long"
          },
          {
            "id": 2,
            "value": "Attempt to acknowledge them in a timely manner"
          },
          {
            "id": 3,
            "value": "Play music to distract them"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "caa2d5e5-28eb-46bf-89cb-eccca37d63cd",
        "type": "SingleChoice",
        "content": "What is a key aspect of active listening?",
        "options": [
          {
            "id": 0,
            "value": "Demonstrating empathy and understanding"
          },
          {
            "id": 1,
            "value": "Interrupting to offer solutions"
          },
          {
            "id": 2,
            "value": "Apologizing profusely"
          },
          {
            "id": 3,
            "value": "Avoiding eye contact with the guest"
          }
        ]
      }
    ],
    "answers": [
      {
        "id": "6d9bb17e-26c6-4f08-b00e-526b2c6d55e4",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "de12f198-4310-4c97-8e0a-6ca8702e3349",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "a7ef20d6-23df-40df-b0d7-a0fcd6f01ccb",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "9dffdb81-0bc3-48da-adef-a721c129e669",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "4e06a134-9ca9-4ccf-a5d9-07edd00b85c2",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "3af84708-9f5a-4a51-8b95-69d5c67a7b5b",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "d9afe4c3-02ca-4c94-ada8-f72fda621fed",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "814def0e-01da-4e8c-a1b9-db530ee3e6a8",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "d7cc3525-dede-4beb-b16b-3eaf51b445cf",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "caa2d5e5-28eb-46bf-89cb-eccca37d63cd",
        "choices": [
          0
        ],
        "isCorrect": true
      }
    ],
    "startsAt": "2024-09-03T21:02:17.5196391+00:00",
    "endsAt": "2024-09-05T21:02:17.5196397+00:00"
  };

export default mock;